import { render } from "./LoggedUsersSummary.vue?vue&type=template&id=f18c1100&scoped=true"
import script from "./LoggedUsersSummary.vue?vue&type=script&lang=js"
export * from "./LoggedUsersSummary.vue?vue&type=script&lang=js"

import "./LoggedUsersSummary.vue?vue&type=style&index=0&id=f18c1100&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f18c1100"]])

export default __exports__